import type * as CFDailyPage from 'services/content/page/types/CFDailyPage'
import DailyModule from 'containers/DailyModule'
import DynamicComponent from 'components/DynamicComponent'

type Props = CFDailyPage.Parsed & {
  onPreviousClick?: () => void
  onNextClick?: () => void
}

function DailyItemContainer(props: Props) {
  const {
    components,
    nextUrl,
    previousUrl,
    slug,
    fullPath,
    onPreviousClick,
    onNextClick,
  } = props

  return (
    <>
      {components.map((component, index) => {
        if (component.name === 'DailyModule') {
          return (
            <DailyModule
              key={`${component.name}_${index}`}
              nextUrl={nextUrl}
              previousUrl={previousUrl}
              onPreviousClick={onPreviousClick}
              onNextClick={onNextClick}
              {...component.props}
              fullPath={fullPath}
              slug={slug}
            />
          )
        } else {
          return (
            <DynamicComponent
              key={`${component.name}_${index}`}
              component={component}
            />
          )
        }
      })}
    </>
  )
}

export default DailyItemContainer
